const config = {
    apiPath: process.env.VUE_APP_API_PATH,
    captchaKey: process.env.VUE_APP_CAPTCHA_KEY,
    scope: process.env.VUE_APP_SCOPE,
    uploadApiPath: process.env.VUE_APP_API_PATH + '/management/attachment/upload',
    uploadPath: process.env.VUE_APP_UPLOAD_PATH,
}

export default config;
